<template>
	<div>
		<div class="colhead">
			<h2 class="header_h2">角色信息管理</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">新增</el-button>
			<el-input v-model="select_word" placeholder="角色名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>

		</el-header>
		<el-main>

			<li style="float: left;width: 70%;">
				<el-card>
					<div slot="header" style="text-align: left;">
						<span><b>角色列表</b></span>
					</div>
					<el-table border ref="multipleTable" @row-click="tbclickRow" tooltip-effect="dark"
						:data="rolelist.slice((currentPage-1)*pagesize,currentPage*pagesize)">

						<el-table-column prop="isused" label="启用">
							<template slot-scope="scope">
								<label v-if='scope.row.isused=="0"'>禁用</label>
								<label v-if='scope.row.isused=="1"'>启用</label>
							</template>
						</el-table-column>
						<el-table-column prop="roletype" label="角色类型" width="120px">
							<template slot-scope="scope1">
								<label v-if='scope1.row.roletype=="0"'>普通用户</label>
								<label v-if='scope1.row.roletype=="1"'>管理员</label>
								<label v-if='scope1.row.roletype=="2"'>超级管理员</label>
							</template>
						</el-table-column>
						<el-table-column prop="rolename" label="角色名称" width="120px"></el-table-column>
						<el-table-column prop="memo" label="备注" width="220px"></el-table-column>
						<el-table-column label="操作" width="150px">
							<template slot-scope="scope2">
								<el-button @click="handleEdit(scope2.$index, scope2.row)" icon="el-icon-edit"
									type="text" size="small">编辑</el-button>
								<el-button @click="SavePermission(scope2.$index, scope2.row)" icon="el-icon-edit"
									type="text" size="small">保存权限</el-button>
							</template>
						</el-table-column>
					</el-table>
					<!-- </el-container> -->
					<el-footer style="margin-top:20px;">
						<template>
							<div class="block">
								<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="currentPage" :page-sizes="[5, 10, 20, 40]" :page-size="pagesize"
									layout="total, sizes, prev, pager, next, jumper" :total="data.length">
								</el-pagination>
							</div>
						</template>
					</el-footer>
				</el-card>
			</li>

			<li style="float: left;width: 30%;">
				<el-card>
					<div slot="header" style="text-align: left;">
						<span ><b>所有权限</b></span>
					</div>
					<el-tree :data="allpermision" ref="p" show-checkbox default-expand-all node-key="code"
						:props="defaultProps" :default-checked-keys="defaultCheckedKeys">
					</el-tree>
				</el-card>

			</li>
		</el-main>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo">
				<el-form-item label="启用">
					<el-switch v-model="EditInfo.isused" active-value="1" inactive-value="0"></el-switch>

				</el-form-item>
				<el-form-item label="角色类型">
					<el-select v-model="EditInfo.roletype" placeholder="请选择角色类型" style="width: 200px;">
						<el-option v-for="item in em_roletype" :key="item.key" :label="item.key" :value="item.value">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="角色名称">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.rolename" placeholder="请输入角色名称">
					</el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input style="display:inline-block;width:80%;" v-model="EditInfo.memo" placeholder="请输入备注">
					</el-input>
				</el-form-item>

			</el-form>
			<!-- 按钮确定和取消 -->
			<span slot="footer">
				<el-button type="primary" @click.native="bao1editSure">确定</el-button>
				<el-button @click.native="bao1edit = false">取消</el-button>
			</span>
		</el-dialog>

		<!-- ----新增个人信息---- -->
		<el-dialog title="新增信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo">
				<el-form-item label="启用">
					<el-switch v-model="AddInfo.isused" active-value="1" inactive-value="0"></el-switch>
				</el-form-item>
				<el-form-item label="角色类型">
					<el-select v-model="AddInfo.roletype" placeholder="请选择角色类型" style="width: 200px;">
						<el-option v-for="item in em_roletype" :key="item.key" :label="item.key" :value="item.value">
							{{ item.key }}
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="角色名称">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.rolename" placeholder="请输入角色名称">
					</el-input>
				</el-form-item>
				<el-form-item label="备注">
					<el-input style="display:inline-block;width:80%;" v-model="AddInfo.memo" placeholder="请输入备注">
					</el-input>
				</el-form-item>
			</el-form>
			<!-- 按钮确定和取消 -->
			<span slot="footer">
				<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
				<el-button @click.native="bao1newadd = false">取消</el-button>
			</span>
		</el-dialog>
	</div>
</template>



<script>
	import role from '../apifunction/Role.js'
	import ems from '../commontools/enums.js'
	import commfun from '../commontools/CommonFun.js'
	import permission from '../apifunction/Permission.js'
	export default {
		data() {
			return {
				rolelist: [],
				permissionlist: [],
				allpermision: [],
				em_roletype: ems.RoleType,
				roletype: '0',
				currentPage: 1,
				pagesize: 10,
				bao1edit: false,
				bao1newadd: false,
				idx: null,
				//   通过姓名查询
				select_word: "",
				defaultProps: {
					children: "children",
					label: "name"
				},
				defaultCheckedKeys: [],
				//   定义初始个人信息
				EditInfo: {
					roleid: '',
					rolename: '',
					roletype: '',
					isused: '',
					memo: ''
				},
				AddInfo: {
					roleid: '',
					rolename: '',
					roletype: '0',
					isused: '1',
					memo: '',
				}
			};
		},
		mounted() {
			this.GetAllRole();
			this.GetAllPermission();
		},
		methods: {
			//   得到所有的数据---------------
			GetAllRole() {
				role.GetAllRole()
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));

						if (ent.Flag == 'success') {
							this.rolelist = JSON.parse(ent.Data);

						}
					})
			},
			GetAllPermission() {
				permission.GetAllPermission()
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));

						if (ent.Flag == 'success') {
							this.permissionlist = JSON.parse(ent.Data);
							this.allpermision = commfun.getPermissionJson(this.permissionlist)
						}
					})
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				this.EditInfo = {
					roleid: row.roleid,
					rolename: row.rolename,
					roletype: row.roletype,
					isused: row.isused,
					memo: row.memo
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				role.EditRole(this.EditInfo)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.rolelist.splice(this.idx, 1, this.EditInfo)
							//this.$set(this.data, this.idx, this.EditInfo);
							this.bao1edit = false;
							this.$message.success("修改成功");
						} else
							this.$message.success(ent.Msg);
					})

			},
			// 新增按钮-----
			baonewAdd() {
				this.bao1newadd = true;
				this.AddInfo.roleid = "";
				this.AddInfo.rolename = "";
				this.AddInfo.roletype = "0";
				this.AddInfo.isused = "1";
				this.AddInfo.memo = '';
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				if (this.AddInfo.rolename == '') {
					this.$message.info("角色名称不能为空！");
					return;
				}
				this.AddInfo.roleid = commfun.NewGuid();
				role.AddRole(this.AddInfo)
					.then(res1 => {
						var ent1 = JSON.parse(JSON.stringify(res1.data))
						if (ent1.Flag == 'success') {
							this.rolelist.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.currentPage = 1;
							this.$message.success("新增成功");
						} else
							this.$message.info(ent1.Msg);
					})
			},
			tbclickRow(row) {
				var checkedp = [];
				if (row.roleid == '' || row.roleid == null) {
					this.$refs.p.setCheckedKeys(checkedp, true);
					return;
				}
				role.GetRolePermissionByRoleID(row.roleid)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							var rolepermissions = JSON.parse(ent.Data);
							var checkedp = [];
							if (rolepermissions != null && rolepermissions.length > 0)
								for (var i = rolepermissions.length - 1; i >= 0; i--) {
									var aa = this.permissionlist.find(c => c.permissionid == rolepermissions[i]
										.permissionid)
									//alert(JSON.stringify(aa));
									if (aa && aa.routeurl != '' && aa.routeurl != null)
										checkedp.push(rolepermissions[i].permissionid);

								}
							// alert(JSON.stringify(checkedp))
							this.$refs.p.setCheckedKeys(checkedp, true);
						}
					})
			},
			SavePermission(index, row) {
				let checkedlist = [].concat(this.$refs.p.getHalfCheckedKeys(),
					this.$refs.p.getCheckedKeys());
				// alert(JSON.stringify(checkedlist))
				role.SavePermission(row.roleid, checkedlist)
					.then(res => {
						var ent = JSON.parse(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							this.$message.success('保存成功！');
							this.tbclickRow(row);
						} else
							this.$message.Error(ent.Msg);
					});
			}
		},
		computed: {
			data() {
				return this.rolelist.filter(item => {
					if (this.select_word == '')
						return item;
					else if (item.rolename.indexOf(this.select_word) > -1) {
						return item;
					}

				});
			}
		}
	};
</script>


<style scoped>
	.colhead {
		padding-bottom: 2px;
		border-bottom: 1px solid #ccc;
		width: 100%;
	}
</style>
